import { useLocation } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import ArdrendHeader from "../components/AllVon/VonHeader/ArdrendHeader";
import VonFooter from "../components/AllVon/VonFooter/VonFooter";


export default function MainLayouts({ children, showFooter = true }) {
  const location = useLocation();
  const isCourseVideoPath = location.pathname.startsWith("/course-video");
  return (
    <>
      <ArdrendHeader alwaysScrolled={true} />
      {children}
      
      {showFooter && (
        <ScrollToTop
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#F05A19",
            color: "#fff",
            // overflow: "hidden"
          }}
          smooth
        />
      )}

      {showFooter && !isCourseVideoPath && <VonFooter />}
    </>
  );
}
